module.exports = __webpack_public_path__ + "static/media/expiry-soft.f6ffd25b.svg";